import React, { useState } from 'react';
import { map } from 'lodash';
import { CircularProgress } from '@mui/material';
import MedicationTable from '../../../Main/components/MedicationTable';
import axios from 'axios';

const headCells = [
  {
    id: 'title',
    numeric: false,
    disablePadding: true,
    label: 'Title',
  },
  {
    id: 'type',
    numeric: false,
    disablePadding: false,
    label: 'Type',
  },
  {
    id: 'start',
    numeric: false,
    disablePadding: false,
    label: 'Start',
  },
  {
    id: 'assignee',
    numeric: false,
    disablePadding: false,
    label: 'Assignee',
  },
];

function TodayEventsList({ user, closeModal, tab }) {
  const [events, setEvents] = useState([]);
  const [loader, setLoader] = useState(false);

  const getTodayEvents = React.useCallback(async () => {
    const userId = tab !== '1' ? tab : user?._id || user?.id || '';
    setLoader(true);
    try {
      let { data } = await axios.get(`${process.env.REACT_APP_EXPRESS_URL}/api/canCare/user/${userId}/getDailyEvents`, {
        headers: {
          'Content-Type': 'application/json',
          authorization: localStorage.getItem('auth'),
        },
      });
      data = map(data?.data, (item, idx) => ({
        id: idx + 1 || 0,
        title: item?.title || '',
        type: item?.type || '',
        start: item?.start || '',
        assignee: item?.assignee || '',
      }));
      setEvents(data || []);
    } catch (exception) {
      console.log('Exception', exception);
    }
    setLoader(false);
  }, [user]);

  React.useEffect(() => {
    getTodayEvents();
  }, [getTodayEvents]);

  return (
    <div style={{ padding: '20px' }}>
      {loader ? (
        <div
          style={{ width: '500px', height: '300px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}
        >
          <CircularProgress style={{ width: '150px', height: '150px', borderRadius: '50%', color: '#26786a' }} />
        </div>
      ) : (
        <MedicationTable rows={events || []} closeModal={closeModal} headCells={headCells} cancare={true} />
      )}
    </div>
  );
}

export default TodayEventsList;
